module.exports = __webpack_public_path__ + "static/media/FENGYUN 2H.f01a1318.czml";